(function () {
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(
        'a[data-instant-action-type="add-to-instant-cart"]'
      );

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantId =
        btn.getAttribute("data-instant-action-variant-id") ||
        (btn.href.match(/\/cart\/(\d+):/) || [])[1];

      if (!variantId) {
        console.warn("Variant ID not found for Instant ATC button");
        return;
      }

      btn.classList.add("is-loading");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Cart add failed");
          return res.json();
        })
        .then(function () {
          if (typeof window.refreshMinicart === "function") {
            window.refreshMinicart();
          }

          var drawer = document.getElementById("kwik-cart-drawer");
          var overlay = document.getElementById("cart-overlay");

          if (drawer && overlay) {
            drawer.hidden = false;
            overlay.hidden = false;
            drawer.setAttribute("aria-hidden", "false");
            document.documentElement.style.overflow = "hidden";
          } else {
            var cartTrigger = document.querySelector("[data-open-cart]");
            if (cartTrigger) cartTrigger.click();
          }
        })
        .catch(function (err) {
          console.error("Mini cart ATC error:", err);

          // Fallback: agar mini cart open/add fail ho to normal cart URL par bhej do
          window.location.href = btn.href;
        })
        .finally(function () {
          btn.classList.remove("is-loading");
        });
    },
    true
  );
})();